import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import classNames from "classnames";

import { Collapse, Icon } from "@/comn/components";
import { routes } from "@/comn/features/router";
import { routeState } from "@/comn/features/recoil";

type NavItemProps = {
    children?: any[];
    depth_1?: any;
    depth_2?: any;
    _base?: string;
    base?: string;
    name?: string;
    to?: string;
    depth?: number;
};

const NavItemm = (props: NavItemProps) => {
    const { children, depth = 1, depth_1, depth_2, _base = "", base = "", to = "", name } = props;
    const _depth = depth + 1;
    const __base = _base + base;
    const navigate = useNavigate();
    const location = useLocation();
    const [open, setOpen] = useState(
        Array.isArray(children) && location.pathname.startsWith(depth_1?.base + depth_2?.base + __base),
    );
    const handleClick = () => {
        if (children) return setOpen((prev) => !prev);
        navigate(to);
    };
    const current = !Array.isArray(children) && location.pathname === depth_1?.base + depth_2?.base + __base + to;

    return (
        <li>
            <button
                className={classNames(
                    "p-1 flex text-[14px] w-full items-center justify-between text-left",
                    _depth === 2 && "font-medium",
                    _depth !== 2 && "text-[13px]",
                )}
                onClick={handleClick}
            >
                <p className={classNames({ "text-blue underline": current })}>{name}</p>
                {children && (
                    <Icon icon="down" size="xs" className={classNames("transition", { "rotate-180": open })} />
                )}
            </button>
            {Array.isArray(children) && (
                <Collapse open={open}>
                    <ul className="pl-4 text-gray dark:text-lightgray">
                        {children.map((child) => {
                            return (
                                <NavItemm
                                    key={depth_1?.base + depth_2?.base + __base + to + (child?.base || child.to)}
                                    depth={_depth}
                                    depth_1={depth_1}
                                    depth_2={depth_2}
                                    _base={__base}
                                    {...child}
                                />
                            );
                        })}
                    </ul>
                </Collapse>
            )}
        </li>
    );
};

export const Dev_NavigationTabMenu = () => {
    const [route] = useRecoilState(routeState);

    const depth_1 = routes.find(({ base }: any) => route.startsWith(base || ""));
    const depth_1_base = (depth_1?.base || "").startsWith("/") ? depth_1?.base || "" : "/" + (depth_1?.base || "");
    const depth_2 = depth_1?.children?.find(({ base }: any) =>
        route.startsWith(depth_1_base + ((base || "").startsWith("/") ? base || "" : "/" + (base || ""))),
    );

    return (
        <nav className="overflow-scroll box-border px-4">
            {depth_1 && depth_2 && (
                <ul className="flex flex-col gap-2">
                    {depth_2?.children?.map((child: any) => {
                        return (
                            <NavItemm
                                key={depth_1.name + "." + child.name}
                                depth_1={depth_1}
                                depth_2={depth_2}
                                {...child}
                            />
                        );
                    })}
                </ul>
            )}
        </nav>
    );
};
